import {QUESTION_ASKED} from '../questionGame/actions'
const SET_ANSWER_MS = 'SET_ANSWER_MS'

export const answerMs = (state = 20000, action) => {
    switch (action.type) {
        case QUESTION_ASKED:
            return action.msToAnswer

        case SET_ANSWER_MS:
            return action.answerMs

        default:
            return state
    }
}

export const setAnswerMs = (answerMs) => {
    return { type: SET_ANSWER_MS, answerMs }
}


// WEBPACK FOOTER //
// ./src/reducers/answerMs/index.js